// src/redux/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk for fetching Home data
export const fetchHomepage = createAsyncThunk(
  "content/fetchFeatures",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://admin.pluglr.com/api/request/home-page");
      return response.data;
    } catch (error) {
      console.error("Error fetching Home data:", error);
      return rejectWithValue(error.response?.data || "An error occurred while fetching Home data");
    }
  }
);

export const fetchPricing = createAsyncThunk(
  "content/fetchPricing",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://admin.pluglr.com/api/request/pricing");
      return response.data;
    } catch (error) {
      console.error("Error fetching Pricing data:", error);
      return rejectWithValue(error.response?.data || "An error occurred while fetching Pricing data");
    }
  }
);

export const fetchCompany = createAsyncThunk(
  "content/fetchCompany",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://admin.pluglr.com/api/request/company");
      return response.data;
    } catch (error) {
      console.error("Error fetching Company data:", error);
      return rejectWithValue(error.response?.data || "An error occurred while fetching Company data");
    }
  }
);

export const fetchGeneral = createAsyncThunk(
  "content/fetchGeneral",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://admin.pluglr.com/api/request/general-settings");
      return response.data;
    } catch (error) {
      console.error("Error fetching General data:", error);
      return rejectWithValue(error.response?.data || "An error occurred while fetching General data");
    }
  }
);

export const fetchTerms = createAsyncThunk(
  "content/fetchTerms",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://admin.pluglr.com/api/request/terms-and-conditions");
      return response.data;
    } catch (error) {
      console.error("Error fetching Company data:", error);
      return rejectWithValue(error.response?.data || "An error occurred while fetching Company data");
    }
  }
);

export const fetchPrivacy = createAsyncThunk(
  "content/fetchPrivacy",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://admin.pluglr.com/api/request/privacy-policy");
      return response.data;
    } catch (error) {
      console.error("Error fetching Company data:", error);
      return rejectWithValue(error.response?.data || "An error occurred while fetching Company data");
    }
  }
);


const homeSlice = createSlice({
  name: "features",
  initialState: {
    data: null,
    homeObject: null,
    pricingObject: null,
    companyObject: null,
    generalObject: null,
      termsObject: null,
      privacyObject: null,
    loading: false,
    error: null,
  },
  reducers: {}, // No synchronous reducers
  extraReducers: (builder) => {
    builder
      // Fetch Home Data
      .addCase(fetchHomepage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomepage.fulfilled, (state, action) => {
        state.loading = false;
        state.homeObject = action.payload;
      })
      .addCase(fetchHomepage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Pricing Data
      .addCase(fetchPricing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPricing.fulfilled, (state, action) => {
        state.loading = false;
        state.pricingObject = action.payload;
      })
      .addCase(fetchPricing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Company Data
      .addCase(fetchCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companyObject = action.payload;
      })
      .addCase(fetchCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch General Data
      .addCase(fetchGeneral.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGeneral.fulfilled, (state, action) => {
        state.loading = false;
        state.generalObject = action.payload;
      })
      .addCase(fetchGeneral.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })      
      // Fetch Terms Data
      .addCase(fetchTerms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTerms.fulfilled, (state, action) => {
        state.loading = false;
        state.termsObject = action.payload;
      })
      .addCase(fetchTerms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Privacy Data
      .addCase(fetchPrivacy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPrivacy.fulfilled, (state, action) => {
        state.loading = false;
        state.privacyObject = action.payload;
      })
      .addCase(fetchPrivacy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  },
});

export default homeSlice.reducer;
